import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/service/api.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import * as _moment from 'moment';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS, MatDatepickerInputEvent } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { numValidation } from 'src/app/service/customValidation';
import { Select2OptionData } from 'ng-select2';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap, switchMap, map } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment.prod';
import { DataPassingService } from 'src/app/service/data-passing.service';

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export interface StandardElement {
  name: string;
  dueAmount: string;
}


@Component({
  selector: 'app-expense',
  templateUrl: './expense.component.html',
  styleUrls: ['./expense.component.css'],
  providers:[
    {provide:DateAdapter,useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ]
})
export class ExpenseComponent implements OnInit {
  isSubmitted=false;
  isSuccess=false;
  isError=false;
  message='';
  inputFormGroup:FormGroup;
  isGreater=false;
  isDisabled=false;
  searching = false;
  searchFailed = false;
  returnData:any=[];
  name='';
  paymentModeList:Array<Select2OptionData>;
  expenseType:Array<Select2OptionData>;
  maxValid=false;
  maxDate=new Date();
  constructor(private formBuilder:FormBuilder,private api:ApiService,private route:ActivatedRoute,private datePipe:DatePipe,private dataPass:DataPassingService) {
    this.inputFormGroup=this.formBuilder.group({
      id:['1'],
      expense:[''],
      expenseName:[''],
      dueDate:[''],
      paidAmount:['',[Validators.required,numValidation()]],
      paymentMode:['',Validators.required],
      reference:[''],
      bank:[''],
      purpose:['']
      
    });
   }

  ngOnInit() {
    this.paymentModeList=[];
    this.expenseType=[];
    this.route.data.subscribe(data=>{
      data.expense[0].data.forEach(element => {
        let aData={id:element.id,text:element.name};
        this.paymentModeList.push(aData);
      });

      data.expense[1].data.forEach(element => {
        let aData={id:element.id,text:element.title};
        this.expenseType.push(aData);
      });
    },(error)=>{});
  }

  saveForm(form)
  {
    this.returnData=[];
    this.isError=false;
    this.isSuccess=false;
    this.isDisabled=true;
    this.isSubmitted=true;
    if(this.inputFormGroup.invalid)
    {
      this.isDisabled=false;
      return false;
    }
    else
    {
      this.expenseType.forEach(el=>{
        if(el.id==form.value.expense)
        {
          form.value.expenseName=el.text;
        }
      });
      form.value.dueDate=(form.value.dueDate!="")?this.datePipe.transform(form.value.dueDate,"dd/MM/yyyy"):'';
      this.api.post(form.value,'expenseMoneyWidraw').subscribe(data=>{
        if(data.status)
        {
          this.message=data.message;
        }
        else
        {
          this.message=data.message;
        }
        alert(this.message);
        this.isSubmitted=false;
        this.isDisabled=false;
        this.inputFormGroup.reset();
        
      },(error)=>{});

    }
  }

  dateTranform()
  {
    let dt=new Date();
    return this.datePipe.transform(dt,"dd/MM/yyyy");
  }

  dateEvent(type: string, event: MatDatepickerInputEvent<any>) {
    this.isDisabled=false;
    this.maxValid=false;
    let dt=event.value._d;
    let nwDt=new Date();
    if(dt>=nwDt)
    {
      this.isDisabled=true;
      this.maxValid=true;
     
      
    }
  }

}
